module.exports = __webpack_public_path__ + "static/img/IMG_20170902_155524.895a81b2.jpg";